import multipleChecks from "@wielink-application/shared/js/mixins/multipleChecks.js";
export default multipleChecks;
